const spacingTokens: { [tokenName: string]: string } = {
  alpha: '4px',
  beta: '8px',
  gamma: '16px',
  omega: '20px',
  delta: '24px',
  omikron: '32px',
  epsilon: '40px',
  zeta: '48px',
};

export default spacingTokens;
